import { IGetClienteCentroCustoByIdUseCase } from "../../../presentation/useCases/read/get_cliente_centro_custo_by_id_use_case";
import { ClienteCentroCusto } from "../../models/clienteCentroCusto";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetClienteCentroCustoByIdUseCase
 */

export class GetClienteCentroCustoByIdUseCase implements IGetClienteCentroCustoByIdUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idClienteCentroCusto: number): Promise<ClienteCentroCusto> {
    return this.repository.getClienteCentroCustoById(idClienteCentroCusto);

  }
}
